import { ADN_PLUS } from './ADN_PLUS';

export class TokenResponseModel {
    public access_token: string;
    public refresh_token: string;
    public token_type: string;
    public expires_in: number;
    public user: ADN_PLUS | any;
    public issued: string;
    public expires: string;

    constructor(obj: any = null) {
        if (obj)
            Object.assign(this, obj);
    }
}
